import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import config from "../../../config";

// components
import Widget from "../../../components/Widget/Widget";
import Table from "./CategoryProductTable";

// styles
import useStyles from "../styles";

export default function CategoryProductSection() {
  const classes = useStyles();
  const history = useHistory();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl + 'categoryProduct/page/');
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    result = allData.filter((data) => {
      return data.name.toLowerCase().includes(value);
    });
    setFilteredData(result);
  }

  const onNextPage = e => {
    if (currentPage < totalPages) {
      fetch(baseUrl + currentPage,
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setAllData(newData);
            setFilteredData(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
          }
        })
        .catch(error => null);
    }
  }

  const onPreviousPage = e => {
    if (currentPage > 1) {
      fetch(baseUrl + (currentPage - 2),
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setAllData(newData);
            setFilteredData(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
          }
        })
        .catch(error => null);
    }
  }

  const fetchUserType = async () => {
    fetch(baseUrl + 0,
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        const newData = data.content;

        if (newData != null) {
          if (data.totalElements == 0) {
            setCurrentPage(0);
          }
          setAllData(newData);
          setFilteredData(newData);
          setTotalPages(data.totalPages);
        }
      })
      .catch(error => {
        setCurrentPage(0);
        setTotalPages(0);
      });
  }

  useEffect(() => {
    fetchUserType();
  }, []);

  return (
    <>
      <div>
        <div className={classes.divTitle}>
          <label className={classes.titleStyle}>Categorías de producto</label>
        </div>

        <div className={classes.divHeader} >
          <div className={classes.div} >
            <input
              className={classes.input}
              type="text"
              onChange={(event) => handleSearch(event)}
            />
            <div className={classes.divSearch} >
              <Icons.Search classes={{ root: classes.searchIcon }} />
            </div>
          </div>

          <div className={classes.divAddButton} >
            <Icons.Add classes={{ root: classes.searchIcon }}
              onClick={() =>
                history.push('/app/addCategoryProduct')
              }
            />
          </div>
        </div>

        <Grid item xs={12}>
          <Widget
            noBodyPadding
            bodyClass={classes.tableWidget}
          >
            <Table
              data={filteredData}
              currentPage={currentPage}
              totalPages={totalPages}
              onPreviousPage={onPreviousPage}
              onNextPage={onNextPage}
            />
          </Widget>
        </Grid>
      </div>
    </>
  );
}
